import { HttpClient } from '@angular/common/http';
import { Injectable, inject, signal } from '@angular/core';
import { Observable, tap } from 'rxjs';

import { environment } from '../../environments/environment';
import { PortalUser } from '../types/portal-user';

@Injectable({ providedIn: 'root' })
export class UserService {
  private readonly http = inject(HttpClient);
  private readonly userSignal = signal<PortalUser | null>(null);

  readonly user = this.userSignal.asReadonly();

  loadCurrentUser(): Observable<PortalUser> {
    return this.http
      .get<PortalUser>(`${environment.apiBaseUrl}/api/me`)
      .pipe(tap((user) => this.userSignal.set(user)));
  }

  clear(): void {
    this.userSignal.set(null);
  }
}
